const UI = () => {
  return <div>404</div>;
};
export default UI;
